module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"files":"Files","file_is_too_big":"File has a higher size than 10mb","add_a_file":"Add a file"},"fr":{"files":"Fichiers","file_is_too_big":"Le fichier a une taille supérieure à 10mo","add_a_file":"Ajouter un fichier"},"de":{"files":"Dateien","file_is_too_big":"Die Datei ist größer als 10 MB","add_a_file":"Fügen Sie eine Datei hinzu"}}')
  delete Component.options._Ctor
}
